import { useCallback } from 'react';
import { Element } from '@thive/canvas';
import { useFloorplanDesignStore } from '@/modules/floorplanDesign/store/useFloorplanDesignStore';
import { AreaPickerServiceFactory } from '@/modules/canvas/services/AreaPicker/AreaPickerServiceFactory';

export const useChooseClick = () => {
  const { getAreaById } = useFloorplanDesignStore();
  const areaPickerSvc = AreaPickerServiceFactory.getInstance().createAreaPickerService();

  const chooseClick = useCallback(
    (element: Element) => {
      const area = getAreaById(element.id);
      if (!area) return;

      areaPickerSvc.complete(area.id);
    },
    [getAreaById, areaPickerSvc],
  );

  return { chooseClick };
};
